 'use strict';

angular.module('schoolbushubApp')
    .factory('notificationInterceptor', function ($q, AlertService) {
        return {
            response: function(response) {
                var alertKey = response.headers('X-schoolbushubApp-alert');
                if (angular.isString(alertKey)) {
                    AlertService.success(alertKey, { param : response.headers('X-schoolbushubApp-params')});
                }
                return response;
            }
        };
    });
